import React, { useEffect, useState } from "react";
import {
  Pie,
  PieChart,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Label,
} from "recharts";
import CustomTooltip from "../customTooltip";
import "./BarchartPie.scss";
import UtilServices from "@services/UtilServices";

// biblioteca https://ui.shadcn.com/charts

export function BarchartPie(props) {
  const [data, setData] = useState();
  const [totalLegenda, setTotalLegenda] = useState();

  useEffect(() => {
    const container = document.querySelector(".barchartmixed");
    const style = getComputedStyle(container);

    const novaArray = props.chartData.map((item, index) => {
      const varIndex = (index % 5) + 1; // 1 a 5
      const cor = `hsl(${style
        .getPropertyValue(`--chart-${varIndex}`)
        .trim()})`;

      return {
        ...item,
        fill: item.fill || cor,
      };
    });
    // Ordena os dados pela chave ou total para garantir a ordem da esquerda para a direita
    // .sort((a, b) => b[props.dataKeyX] - a[props.dataKeyX]); // Ordenando por total (ou qualquer métrica)
    setData(novaArray);

    const totalLegenda = props.chartData.reduce(
      (acc, curr) => acc + curr[props.dataKey],
      0,
    );
    setTotalLegenda(totalLegenda);
  }, [props.chartData]);

  return (
    <>
      {props.title !== null && (
        <p className="titleBarchartPie">{props.title}</p>
      )}
      <div
        className="barchart-pie"
        style={{ width: "100%", height: props.height }}
      >
        <ResponsiveContainer>
          <PieChart>
            <Pie
              className={`${props.cursorpoint ? "cursorp" : ""}`}
              data={data}
              dataKey={props.dataKey}
              nameKey={props.nameKey}
              innerRadius={60}
              minAngle={10}
              stroke="none" // remove o contorno
              label={
                props.label
                  ? ({ name, value }) => `${value.toLocaleString()}`
                  : false
              }
              onClick={(data, index) => {
                props.functionClick(data);
              }}
            >
              {props.totalLegenda && (
                <Label
                  content={({ viewBox }) => {
                    if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                      return (
                        <text
                          x={viewBox.cx}
                          y={viewBox.cy}
                          textAnchor="middle"
                          dominantBaseline="middle"
                          className="total-legenda"
                        >
                          <tspan
                            x={viewBox.cx}
                            y={viewBox.cy}
                            className="fill-muted-foreground text-3xl font-bold"
                          >
                            {totalLegenda.toLocaleString()}
                          </tspan>
                          <tspan
                            x={viewBox.cx}
                            y={(viewBox.cy || 0) + 24}
                            className="fill-muted-foreground"
                          >
                            {UtilServices.primeiraLetraMaiuscula(props.dataKey)}
                          </tspan>
                        </text>
                      );
                    }
                  }}
                />
              )}
            </Pie>
            <Tooltip
              content={<CustomTooltip hideLabel hideName={false} />}
              cursor={false} //Remove o fundo branco.
            />
            {props.legenda && (
              <Legend
                layout={props.legendaLayout}
                align={props.legendaAlign}
                verticalAlign={props.legendaVerticalAlign}
                iconType={props.legendaIconType}
                onClick={(data, index) => {
                  props.functionClick(data);
                }}
              />
            )}
          </PieChart>
        </ResponsiveContainer>
      </div>
    </>
  );
}
BarchartPie.defaultProps = {
  //BarChart
  chartData: [
    { key: "chrome", total: 275, fill: "" },
    { key: "safari", total: 200, fill: "" },
    { key: "firefox", total: 187, fill: "" },
    { key: "edge", total: 173, fill: "" },
    { key: "other", total: 90, fill: "" },
  ],
  height: 250,
  //XAxis
  nameKey: "key",
  //Bar
  dataKey: "total",
  BarPositionLabel: "top",
  BarFontSize: 16,
  lstLabel: [],
  functionClick: () => null,
  cursorpoint: true,
  title: null,
  //Legendas
  legenda: true,
  legendaLayout: "vertical",
  legendaAlign: "left",
  legendaVerticalAlign: "middle",
  legendaIconType: "circle",
  //totalLegenda
  totalLegenda: true,
  //Label
  label: false,
};
